import React, { useState } from 'react';
import { View, Text, StyleSheet, SafeAreaView, ScrollView, TouchableOpacity, TextInput, Platform } from 'react-native';
import { Colors, SIZES } from '../../constants/theme';
import { validarTelefono } from '../../utils/telefono';
import { Ionicons } from '@expo/vector-icons';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { GlassView } from 'expo-glass-effect';
import * as ImagePicker from 'expo-image-picker';
import Button3D from '../../components/Button3D';
import { storageService } from '../../services/storageService';
import { callSubmitCandidateOnboarding } from '../../services/cloudFunctions';
import { useAppStore } from '../../store/useAppStore';
import { ActivityIndicator, Alert } from 'react-native';
import { mensajeDeError } from '../../utils/mensajeDeError';

export default function OnboardScreen() {
  const { id } = useLocalSearchParams();
  const router = useRouter();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const myUid = useAppStore((s) => s.userFirebaseUid);
  const [driverName, setDriverName] = useState('');
  const [driverPhone, setDriverPhone] = useState('');
  // FIX AUDIT — Antes los "documentos" eran booleanos simulados (handleUpload
  // solo ponía true). Ahora se suben DE VERDAD a Storage y guardamos su URL.
  const [docUrls, setDocUrls] = useState<{ id?: string; conduct?: string; license?: string }>({});
  const [uploadingType, setUploadingType] = useState<'id' | 'conduct' | 'license' | null>(null);
  // V51 — Antes leía users/{dueño} para poner su nombre, pero las reglas de
  // /users solo dejan leer el perfil propio: la lectura se denegaba siempre.
  // No hay un dato público con el nombre del negocio, así que no se intenta.
  const ownerName = 'este Rent Car';

  // V09 — En web (el enlace se abre desde WhatsApp en el navegador) Alert.alert
  // de react-native-web no hace nada: el candidato no veía ningún aviso.
  const avisar = (titulo: string, mensaje: string) => {
    if (Platform.OS === 'web') {
      window.alert(`${titulo}

${mensaje}`);
    } else {
      Alert.alert(titulo, mensaje);
    }
  };

  const handleUpload = async (type: 'id' | 'conduct' | 'license') => {
    if (uploadingType) return;
    if (!myUid) {
      avisar('Inicia sesión', 'Debes iniciar sesión en Go Safely (con tu cédula verificada) para enviar tus documentos.');
      return;
    }
    try {
      const result = await ImagePicker.launchImageLibraryAsync({ mediaTypes: ['images'], quality: 0.8 });
      if (result.canceled || !result.assets?.[0]) return;
      setUploadingType(type);
      const uri = result.assets[0].uri;
      const path = `rentcar_onboarding/${id}/${myUid}/${type}_${Date.now()}.jpg`;
      const url = await storageService.uploadToPath(path, uri);
      setDocUrls((prev) => ({ ...prev, [type]: url }));
    } catch (e: any) {
      avisar('Error', 'No pudimos subir el documento. Intenta de nuevo.');
    } finally {
      setUploadingType(null);
    }
  };

  const isComplete = !!docUrls.id && !!docUrls.conduct && !!docUrls.license && driverName.trim().length > 3 && driverPhone.trim().length > 8;

  const handleSubmit = async () => {
    // El teléfono del candidato no lo validaba NADIE: ni aquí ni el servidor
    // (`submitCandidateOnboarding` solo recorta a 20 caracteres). Lo único que
    // se miraba era que la cadena tuviera más de 8 caracteres, en `isComplete`.
    // Y ese número es por donde el dueño de la flota llama a quien le va a
    // entregar un carro.
    const telCandidato = validarTelefono(driverPhone);
    if (!telCandidato.ok) {
      avisar('Revisa el número', telCandidato.motivo);
      return;
    }

    if (!myUid) {
      avisar('Inicia sesión', 'Debes iniciar sesión en Go Safely (con tu cédula verificada) para completar tu registro.');
      return;
    }
    if (!isComplete) {
      avisar('Datos incompletos', 'Por favor llena tu nombre, teléfono y sube todos tus documentos.');
      return;
    }
    if (typeof id !== 'string' || !id) {
      avisar('Enlace inválido', 'No pudimos identificar al Rent Car de este enlace.');
      return;
    }
    setLoading(true);
    try {
      // FIX AUDIT — Antes llamaba firestoreService.onboardDriverToCRM (escritura
      // directa) que las reglas RECHAZABAN (el candidato no es el dueño). Ahora
      // usa la callable submitCandidateOnboarding (Admin SDK server-side).
      const res: any = await callSubmitCandidateOnboarding({
        ownerId: id,
        name: driverName.trim(),
        phone: driverPhone.trim(),
        idDocUrl: docUrls.id ?? null,
        licenseUrl: docUrls.license ?? null,
        conductUrl: docUrls.conduct ?? null,
      });
      if (res?.data?.ok) {
        avisar('¡Registro enviado!', 'El dueño del vehículo recibió tus datos y documentos para revisión.');
        // ⚠️ ANTES AQUÍ SE IBA A LA PORTADA, Y AHÍ SE PERDÍA.
        // El candidato mandaba sus papeles y la app lo devolvía al selector de
        // roles, sin decirle qué pasaba después ni dónde mirarlo. Su ficha vive
        // en `users/{dueño}/crm_drivers`, que las reglas solo dejan leer AL
        // DUEÑO: no tenía NINGUNA forma de saber si lo habían aprobado.
        router.replace('/mi-postulacion' as any);
      } else {
        avisar('No se pudo enviar', 'Intenta de nuevo en un momento.');
      }
    } catch (e: any) {
      console.error(e);
      avisar('Error', mensajeDeError(e, 'No pudimos enviar tus datos. Revisa tu conexión e intenta de nuevo.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <SafeAreaView style={styles.safeArea}>
      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.header}>
          <TouchableOpacity onPress={() => router.canGoBack() ? router.back() : router.replace('/')} style={[styles.backBtn, {flexDirection: 'row', alignItems: 'center', backgroundColor: 'rgba(255,255,255,0.8)', borderRadius: 20}]}>
            <Ionicons name="arrow-back" size={28} color={Colors.primary} />
            <Text style={{color: Colors.primary, fontWeight: 'bold', marginLeft: 4, marginRight: 8}}>Volver</Text>
          </TouchableOpacity>
          <View style={styles.iconContainer}>
            <Ionicons name="shield-checkmark" size={40} color={Colors.primary} />
          </View>
          <Text style={styles.title}>Registro de Chofer</Text>
          <Text style={styles.subtitle}>Únete a la flota de {ownerName}</Text>
        </View>

        {!myUid && (
          <View style={styles.infoBox}>
            <Ionicons name="log-in" size={24} color={Colors.accent} />
            <TouchableOpacity style={{ flex: 1 }} onPress={() => router.push('/auth')}>
              <Text style={styles.infoText}>
                Para enviar tus documentos necesitas iniciar sesión en Go Safely con tu cédula verificada.
                Toca aquí para iniciar sesión y luego vuelve a abrir este enlace.
              </Text>
            </TouchableOpacity>
          </View>
        )}

        <GlassView style={styles.card} colorScheme="dark">
          <Text style={styles.cardTitle}>1. Datos Personales</Text>
          
          <Text style={styles.inputLabel}>Nombre Completo</Text>
          <TextInput 
            value={driverName} 
            onChangeText={setDriverName} 
            placeholder="Ej. Juan Pérez" 
            placeholderTextColor={Colors.textSecondary}
            style={styles.textInput} 
          />

          <Text style={styles.inputLabel}>Teléfono</Text>
          <TextInput 
            value={driverPhone} 
            onChangeText={setDriverPhone} 
            placeholder="Ej. 809-555-5555" 
            keyboardType="phone-pad"
            placeholderTextColor={Colors.textSecondary}
            style={styles.textInput} 
          />
        </GlassView>

        <GlassView style={styles.card} colorScheme="dark">
          <Text style={styles.cardTitle}>2. Documentos Requeridos</Text>
          {/* QUIÉN REVISA ESTO. `submitCandidateOnboarding`
              (functions/src/drivers.ts) guarda los tres documentos en el CRM
              del DUEÑO con `status: 'PENDING_REVIEW'` y le manda un push. Go
              Safely no los valida ni los mira: quien decide es el dueño del
              carro. Decir "requerimos validar tus antecedentes" hacía creer
              que había una comprobación nuestra que no existe. */}
          <Text style={styles.cardSubtitle}>Estos tres documentos van directo al dueño del vehículo, que es quien los revisa antes de entregarte el carro.</Text>

          <TouchableOpacity 
            style={[styles.uploadBox, docUrls.id && styles.uploadBoxSuccess]} 
            onPress={() => handleUpload('id')}
          >
            <Ionicons name={docUrls.id ? "checkmark-circle" : "card"} size={30} color={docUrls.id ? "#4CAF50" : Colors.textSecondary} />
            <View style={styles.uploadTextContainer}>
              <Text style={styles.uploadTitle}>Cédula de Identidad</Text>
              {/* SUBIR NO ES VALIDAR. Lo único que ocurrió al llegar aquí es
                  que `handleUpload` guardó la foto en Storage; nadie la ha
                  mirado todavía. Los tres subtítulos decían "validado". */}
              <Text style={styles.uploadSubtitle}>{docUrls.id ? 'Foto subida' : 'Sube foto frontal y reversa'}</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity 
            style={[styles.uploadBox, docUrls.license && styles.uploadBoxSuccess]} 
            onPress={() => handleUpload('license')}
          >
            <Ionicons name={docUrls.license ? "checkmark-circle" : "car"} size={30} color={docUrls.license ? "#4CAF50" : Colors.textSecondary} />
            <View style={styles.uploadTextContainer}>
              <Text style={styles.uploadTitle}>Licencia de Conducir</Text>
              <Text style={styles.uploadSubtitle}>{docUrls.license ? 'Foto subida' : 'Debe estar vigente'}</Text>
            </View>
          </TouchableOpacity>

          <TouchableOpacity 
            style={[styles.uploadBox, docUrls.conduct && styles.uploadBoxSuccess]} 
            onPress={() => handleUpload('conduct')}
          >
            <Ionicons name={docUrls.conduct ? "checkmark-circle" : "document-text"} size={30} color={docUrls.conduct ? "#4CAF50" : Colors.textSecondary} />
            <View style={styles.uploadTextContainer}>
              <Text style={styles.uploadTitle}>Papel de Buena Conducta</Text>
              {/* "Validado por Procuraduría" era lo más grave de los tres: la
                  app no consulta a la Procuraduría por ninguna vía, y el
                  candidato quedaba convencido de que su antecedente estaba
                  comprobado por subir una foto. */}
              <Text style={styles.uploadSubtitle}>{docUrls.conduct ? 'Foto subida' : 'Debe tener menos de 30 días'}</Text>
            </View>
          </TouchableOpacity>
        </GlassView>

        <View style={styles.infoBox}>
          <Ionicons name="information-circle" size={24} color={Colors.accent} />
          {/* ── ESTO ERA AL REVÉS ────────────────────────────────────────
              No hay ninguna validación de Go Safely antes de compartir nada:
              `submitCandidateOnboarding` escribe los documentos en el CRM del
              dueño y le manda el push EN LA MISMA LLAMADA. Los Términos
              (punto 4) ya lo dicen así: el dueño es otro usuario, no un
              empleado nuestro, y ve tu nombre, tu teléfono y las fotos de tus
              tres documentos en cuanto envías este formulario. */}
          <Text style={styles.infoText}>Al enviar este formulario, el dueño del vehículo ve tu nombre, tu teléfono y las fotos de tus tres documentos. Es otro usuario de Go Safely, no un empleado nuestro: es quien te va a entregar el carro. Nadie más los recibe.</Text>
        </View>

        {loading ? (
          <ActivityIndicator size="large" color={Colors.primary} style={{ marginVertical: 20 }} />
        ) : (
          <Button3D 
            title="Completar Registro" 
            color={isComplete ? Colors.primary : Colors.textSecondary}
            onPress={handleSubmit}
            style={styles.submitBtn}
          />
        )}
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: Colors.background,
  },
  container: {
    padding: SIZES.padding,
    paddingTop: 40,
    paddingBottom: 60,
  },
  header: {
    alignItems: 'center',
    marginBottom: 30,
    position: 'relative',
  },
  backBtn: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: 10,
    zIndex: 10,
  },
  iconContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: 'rgba(0, 200, 83, 0.1)',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: Colors.text,
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 16,
    color: Colors.accent,
    fontWeight: '600',
  },
  card: {
    padding: 20,
    borderRadius: 24,
    marginBottom: 20,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: Colors.text,
    marginBottom: 10,
  },
  cardSubtitle: {
    fontSize: 14,
    color: Colors.textSecondary,
    marginBottom: 20,
    lineHeight: 20,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: Colors.text,
    marginTop: 12,
    marginBottom: 6,
  },
  textInput: {
    height: 48,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.2)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    paddingHorizontal: 15,
    color: '#FFF',
    fontSize: 15,
    marginBottom: 10,
  },
  uploadBox: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.1)',
    padding: 15,
    borderRadius: 16,
    marginBottom: 15,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  uploadBoxSuccess: {
    backgroundColor: 'rgba(76, 175, 80, 0.1)',
    borderColor: 'rgba(76, 175, 80, 0.3)',
  },
  uploadTextContainer: {
    marginLeft: 15,
    flex: 1,
  },
  uploadTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: Colors.text,
  },
  uploadSubtitle: {
    fontSize: 12,
    color: Colors.textSecondary,
    marginTop: 2,
  },
  infoBox: {
    flexDirection: 'row',
    backgroundColor: 'rgba(230, 74, 25, 0.1)',
    padding: 15,
    borderRadius: 16,
    marginBottom: 30,
    alignItems: 'flex-start',
  },
  infoText: {
    flex: 1,
    color: Colors.textSecondary,
    fontSize: 12,
    marginLeft: 10,
    lineHeight: 18,
  },
  submitBtn: {
    height: 60,
  }
});
